import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { limpiarServicioConfiguracion, obtenerServicioConfiguracion, editarServicioConfiguracion } from '../../../actions/configuracion';

const EditarServicio = ({ servicio, reestablecerServicio }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.servicios);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [servicioData, setServicioData] = useState({
        id: null,
        nombre: null
    });

    /* Editar servicio */
    const handleInputChange = ({ target }) => {
        setServicioData({
            ...servicioData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(servicioData.nombre){
            await setStatusProcesar(true);
            await dispatch(editarServicioConfiguracion(servicioData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setServicioData({
                id: null,
                nombre: null
            });
            setEditarModal(false);
            reestablecerServicio(null);
        }
    }

    useEffect(() => {
        dispatch(limpiarServicioConfiguracion());
    }, []);

    useEffect(() => {
        if(servicio){
            setEditarModal(true);
            
            dispatch(obtenerServicioConfiguracion(servicio?._id));

            setServicioData({
                ...servicioData,
                id: servicio?._id
            });
        }
    }, [servicio]);

    useEffect(() => {
        if(detalles){
            setServicioData({
                ...servicioData,
                id: detalles?._id, 
                nombre: detalles?.nombre
            });
        }
    }, [detalles]);

    return (
        <Modal show={editarModal} backdrop="static" size="md" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar servicio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={servicioData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarServicio;